"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _reactResizeDetector = require("react-resize-detector");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    padding: props => {
      return theme.spacing(props.padding);
    },
    width: "100%",
    maxWidth: props => {
      return props.maxWidth;
    }
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    margin: props => {
      return theme.spacing(props.spacing * -0.5);
    }
  },
  item: {
    width: props => {
      return props.width + "px";
    },
    maxWidth: props => {
      return props.maxWidth + "px";
    },
    margin: props => {
      return theme.spacing(props.spacing * 0.5);
    } //        overflow: "hidden",

  }
}));

const calculateCutOff = ({
  rowWidth,
  delta,
  spacing,
  row = []
}) => {
  //    console.log('delta', delta)
  let cutoff = [];
  let cutsum = 0;

  for (var i in row) {
    var item = row[i];
    var fractOfLen = item.maxWidth / rowWidth; //        console.log('fractOfLen', fractOfLen)

    cutoff[i] = Math.floor(fractOfLen * delta);
    cutsum += cutoff[i];
  } //    console.log('cutoff', cutoff)


  var stillToCutOff = delta - cutsum;

  while (stillToCutOff > 0) {
    for (i in cutoff) {
      cutoff[i]++;
      stillToCutOff--;
      if (stillToCutOff < 0) break;
    }
  }

  return cutoff;
};

const getGalleryRow = ({
  maxWidth,
  gap,
  items = []
}) => {
  const rowPlusGap = maxWidth + gap;
  var row = [];
  var rowWidth = 0; //    console.log('items', items)

  while (items.length > 0 && rowWidth < rowPlusGap) {
    let item = items.shift();
    row.push(item);
    rowWidth += item.maxWidth + gap; //        console.log('rowWidth' + rowWidth)
  }

  let delta = rowWidth - rowPlusGap; //    console.log('delta', + delta)

  if (row.length > 0 && delta > 0) {
    var cutoff = calculateCutOff({
      rowWidth,
      gap,
      delta,
      row
    });

    for (var i in row) {
      var pixelsToRemove = cutoff[i];
      let item = row[i];
      item.maxWidth = item.maxWidth - pixelsToRemove;
    }
  } else {
    for (var j in row) {
      let item = row[j];
      item.maxWidth = item.maxWidth;
    }
  }

  return row;
};

const getGalleryItem = ({
  props
}) => {
  const maxWidth = props.width || props.mediaWidth;
};

const getGallery = ({
  maxWidth,
  maxRows,
  gap,
  children
}) => {
  if (!children.length) return [];
  if (!maxWidth) return [];

  const items = _react.default.Children.toArray(children).map((child, index) => {
    return _extends({}, child.props, {
      maxWidth: child.props.width * 1
    });
  }); //    console.log('items', items)


  let rows = [];

  while (items.length > 0) {
    rows.push(getGalleryRow({
      maxWidth,
      gap,
      items
    }));
  }

  let cols = [];

  for (var r in rows) {
    for (var i in rows[r]) {
      var item = rows[r][i];

      if (maxRows) {
        if (r < maxRows) {
          cols.push(item);
        }
      } else {
        cols.push(item);
      }
    }
  }

  return cols;
};

const GalleryItem = (_ref) => {
  let _ref$width = _ref.width,
      width = _ref$width === void 0 ? 180 : _ref$width,
      maxWidth = _ref.maxWidth,
      spacing = _ref.spacing,
      children = _ref.children,
      debug = _ref.debug,
      props = _objectWithoutPropertiesLoose(_ref, ["width", "maxWidth", "spacing", "children", "debug"]);

  const classes = useStyles(_extends({}, props, {
    width,
    maxWidth,
    spacing
  }));
  return _react.default.createElement("div", {
    className: classes.item
  }, children, debug && _react.default.createElement("div", null, width, "/", maxWidth));
};

const LayoutGallery = ({
  width = 720,
  spacing = 1,
  padding = 0,
  children,
  debug = false
}) => {
  const maxWidth = width - padding * 8 * 2;
  const gap = spacing * 8;
  const classes = useStyles({
    maxWidth: width,
    padding,
    spacing
  });
  const gallery = getGallery({
    maxWidth,
    gap,
    children
  });
  return _react.default.createElement("section", {
    className: classes.root,
    "data-layout": "gallery"
  }, _react.default.createElement("div", {
    className: classes.list
  }, children.map((child, index) => {
    child = _react.default.cloneElement(child, {
      maxWidth: gallery[index] && gallery[index].maxWidth
    });
    return _react.default.createElement(GalleryItem, _extends({}, child.props, {
      debug: debug,
      spacing: spacing,
      key: index
    }), child);
  })));
};

LayoutGallery.propTypes = process.env.NODE_ENV !== "production" ? {
  spacing: _propTypes.default.any,
  padding: _propTypes.default.number,
  children: _propTypes.default.node
} : {};

var _default = (0, _reactResizeDetector.withResizeDetector)(LayoutGallery);

exports.default = _default;
module.exports = exports.default;